// Central image registry. People-free solar imagery only.
const G = "https://static.prod-images.emergentagent.com/jobs/34ce6dae-1eed-451b-9e45-dae612a1e3ba/images";

export const IMG = {
  hero: `${G}/16e4f8bdf212a662c0e96df8ec77fedd97a1aeb9c44af7b727c996eceef375cd.jpeg`,
  truck: `${G}/dbbb3b99330c6b01285188e480a30adef3aef1d570e22f23348e1ca65636cec3.jpeg`,
  equipment: `${G}/8256397f6e4e795e72949a13089efaa6d4be005f2ae0ca6449d8f6a086a4b85a.jpeg`,
  panelClean: `${G}/4bcda9870cdfba9dbd7145158c0804a7642651997b309c07138ece6bf6a3c80d.jpeg`,
  panelDirty: `${G}/8966b22f0e0bfea2b4a8e163d2c1ec08ec40284730076bcabe8f94cf2834ae4d.jpeg`,
  texas: `${G}/56e2f33da6b2d102d5a966d19fcbd3de8f5fe00d1e2ef5de2fcb16f2bda4e63f.jpeg`,

  // Residential
  res1: "https://images.pexels.com/photos/12243093/pexels-photo-12243093.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  res2: "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  res3: "https://images.unsplash.com/photo-1583345237708-add35a664d77?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  res4: "https://images.unsplash.com/photo-1771479755055-6a305f50845e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",

  // Commercial
  comm1: "https://images.unsplash.com/photo-1758304481667-71d545c91241?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  comm2: "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  comm3: "https://images.unsplash.com/photo-1768677432858-b9a8608dd849?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",

  // Utility solar farms
  farm1: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  farm2: "https://images.pexels.com/photos/6996421/pexels-photo-6996421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  farm3: "https://images.unsplash.com/photo-1723133371535-1412bc2e412e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  farm4: "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
  farm5: "https://images.pexels.com/photos/9800107/pexels-photo-9800107.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  farmSunset: "https://images.unsplash.com/photo-1780922576334-8f8d4e8740cf?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1000",
};
